import { MarketingProcessCode } from '../../../constants';

export const isScalingEgProcess = (
  process: string | undefined,
): process is typeof MarketingProcessCode.SCALING_EG =>
  process === MarketingProcessCode.SCALING_EG;

export const isSimplifiedFlowProcess = (
  process: string | undefined,
): boolean =>
  process === 'inbox' || isScalingEgProcess(process);

export const isPackBasedMarketingProcess = (
  code: MarketingProcessCode,
): boolean =>
  code === MarketingProcessCode.TESTING || code === MarketingProcessCode.SCALING;
